import { serviceConsumer } from "../network/ServiceConsumer";

export const getIsTeacher = async (setLoading) => {
    const url = `${process.env.REACT_APP_BASE_URL}/user`;
    setLoading(true);
    try {
        const response = await serviceConsumer("GET", url)
        localStorage.setItem("isTeacher", response?.teacher);
        localStorage.setItem("isAdjudicator", !!response?.adjudicator);
        localStorage.setItem("Region", response?.country);
        setLoading(false);
    } catch (error) {
        setLoading(false);
    }
}